import React, { FC, useState, RefObject } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
	AppBar, Toolbar, Box, Typography, 
	Drawer, List, ListItem, ListItemText,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';

import Logo from 'assets/logo.svg'; 
import iconFb from 'assets/button-fb.png'; 
import iconIg from 'assets/button-ig.png';

import CenterImage from 'components/common/CenterImage';

const useStyles = makeStyles((theme) => ({
	appBar: {
		height: 80,
		justifyContent: 'center',
	},
	toolbar: {
		minHeight: 80,
		paddingLeft: 42,
		paddingRight: 54,
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			padding: 0,
			justifyContent: 'center',
		},
	},
	logo: {
		objectFit: 'contain',
	},
	menuIcon: {
		display: 'none',
		position: 'absolute',
		right: 20,
		[theme.breakpoints.down('xs')]: {
			display: 'block',
		},
	},
	

	rightGroup: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 'auto',
		height: '100%',

		[theme.breakpoints.down('xs')]: {
			display: 'none', 
		},
	},
	textButtonWrapper: { // 包含上方AppBar的文字按鈕右方的線
		height: 36,
		display: 'flex',
		alignItems: 'center',
		padding: '2px 8px',
		borderRight: '1px solid #fff',
		cursor: 'pointer',
		background: 'transparent',
		border: 'none',
		outline: 'none',
	},

	imageButton: {
		display: 'flex',
		alignItems: 'center'
	},
	iconButton: {
		width: 32,
		height: 32,
		cursor: 'pointer',
	},

	drawer: {
		position: 'relative',
		width: 194,
		backgroundColor: 'var(--color-primary)',
		color: 'var(--color-white)',
	},
	closeIcon: {
		position: 'absolute',
		top: 24,
		right: 17,
		zIndex: 1000,
	},
	drawerList: {
		padding: '75px 5px 0 10px',
		'& span': {
			fontSize: 24,
			color: 'var(--color-white)',
		}
	}
}));

const ImageLinkButton: FC<{ href: string, src: string, alt: string, style?: React.CSSProperties }> = ({ 
	href, src, alt, style = {}
}) => {
	const classes = useStyles();
	return (<a 
		href={ href } target="_blank" style={ style }
		rel="noopener noreferrer" className={classes.imageButton}
	>
		<img src={src} alt={alt} className={classes.iconButton} />
	</a>)
}


interface Props {
  voteRef: RefObject<HTMLElement>;
  rulesRef: RefObject<HTMLElement>;
  winnerRef: RefObject<HTMLElement>;
  invoiceRef: RefObject<HTMLElement>;
  noiceRef: RefObject<HTMLElement>;
}

const HomeAppBar: FC<Props> = ({ voteRef, rulesRef, winnerRef, invoiceRef, noiceRef}) => {
	const classes = useStyles();
	const [drawerOpen, setDrawerOpen] = useState(false);
	const appbarLinkArray = [
		{
			label: '線上投票',
			onClick: () => {
				scrollToTarget(voteRef)
			},
		},
		{
			label: '活動辦法',
			onClick: () => {
				scrollToTarget(rulesRef)
			},
		},
		{
			label: '投票得獎公布',
			onClick: () => {
				scrollToTarget(winnerRef)
			},
		},
		{
			label: '發票登錄',
			onClick: () => {
				scrollToTarget(invoiceRef)
			},
		},
		{
			label: '發票得獎公布',
			onClick: () => {
				scrollToTarget(winnerRef)
			},
		},
		{
			label: '注意事項',
			onClick: () => {
				scrollToTarget(noiceRef)
			},
		},
	];

	const scrollToTarget = (targetRef: RefObject<HTMLElement>) => {
		if (targetRef.current) {
		const rect = targetRef.current.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const targetPosition = rect.top + scrollTop - 100; // 使目標距離畫面頂端 100px
		// const targetPosition = rect.top + scrollTop - window.innerHeight / 2 + rect.height / 2;
		window.scrollTo({ top: targetPosition, behavior: 'smooth' });
		}
	}

	return (<>
		<AppBar position="static">
			<Toolbar className={classes.toolbar}>
				<a 
					href={ "https://www.youshoku.com.tw/" } 
					rel="noopener noreferrer" target="_blank">
					<CenterImage src={Logo} className={classes.logo} alt="Logo" maxWidth={184} />
				</a>
				
				<Box className={classes.rightGroup}>
					{appbarLinkArray.map((item, idx) => (
						<button key={idx} className={classes.textButtonWrapper} onClick={item.onClick}>
							<Typography variant="button">{item.label}</Typography>
						</button>
					))}
					<ImageLinkButton
						href="https://www.facebook.com/house.curry.tw?locale=zh_TW" 
						src={iconFb} 
						alt="Facebook Icon"
						style={{ paddingLeft: 16 }}
					/>
					<ImageLinkButton
						href="https://www.instagram.com/housefoodtw/"
						src={iconIg}
						alt="Instagram Icon"
						style={{ paddingLeft: 16 }}
					/>
				</Box>

				<div className={classes.menuIcon}
					onClick={() => setDrawerOpen(true)}
				>
					<MenuIcon className={classes.iconButton} />
				</div>
				
			</Toolbar>
		</AppBar>

		<Drawer
			anchor="left"
			open={drawerOpen}
			classes={{ paper: classes.drawer }}
			onClose={() => setDrawerOpen(false)}
			// ModalProps={{
			// 	disableBackdropClick: true, // 禁止點 backdrop 關閉
			// 	disableEscapeKeyDown: true, // 禁止 ESC 關閉
			// }}
		>

			<div className={classes.closeIcon}
				onClick={() => setDrawerOpen(false)}
			>
				<CloseIcon className={classes.iconButton} />
			</div>

			<List className={classes.drawerList}>
				{appbarLinkArray.map((item, idx) => (
					<ListItem button key={idx} onClick={item.onClick}>
						<ListItemText primary={item.label} />
					</ListItem>
				))}
				<ListItem>
					<ImageLinkButton
						href="https://www.facebook.com/house.curry.tw?locale=zh_TW" 
						src={iconFb} 
						alt="Facebook Icon"
						style={{ paddingRight: 16 }}
					/>
					<ImageLinkButton
						href="https://www.instagram.com/housefoodtw/"
						src={iconIg}
						alt="Instagram Icon"
					/>
				</ListItem>
			</List>

		</Drawer>
	</>);
};

export default HomeAppBar;
